import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { trackCtaClick } from "../../lib/analytics";

// Appears after the user has scrolled past ~40% of the landing page on mobile
// only — the desktop header CTA stays visible, so the sticky bar would just be
// noise. Hidden by default (`md:hidden`).
export function StickyMobileCta() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    function onScroll() {
      const doc = document.documentElement;
      const scrolled = window.scrollY + window.innerHeight;
      const height = doc.scrollHeight;
      if (height <= window.innerHeight) return;
      setVisible(scrolled / height > 0.4);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-rule bg-paper/95 backdrop-blur px-4 py-3 flex items-center justify-between gap-3 shadow-[0_-8px_24px_rgba(0,0,0,0.08)]">
      <span className="text-xs text-muted-foreground font-mono">
        free · no card
      </span>
      <Link
        to="/register"
        onClick={() =>
          trackCtaClick("sticky", { target: "register", surface: "landing" })
        }
      >
        <Button size="sm">Start free →</Button>
      </Link>
    </div>
  );
}
